module.exports = __webpack_public_path__ + "static/img/hylive.7cab97f8.jpg";